import axios from 'axios';
import {TAMTAM_API_URL, TTP_API_URL, MERCHANTACCOUNT, SKINCODE, MERCHANTREFERENCE, HMAC, PSPID} from 'Config';
import {throwCatchedError} from 'utils';
import {CURRENCY} from 'Common';

export const updatePaymentStatus = (token, orderId) => {
    const requestUrl = TTP_API_URL+`/payment/payment/paymentTest`;
    return axios.get(requestUrl, {
        params: {
            access_token: token,
            orderId: orderId,
        }
    });
};

export const getOrders = (token, orderId) => {
  const requestUrl = TTP_API_URL+`/billing/order`;
  let filter = [];
  filter.push({
    property: 'id',
    value: orderId,
    operator: 'eq'
  });
  return axios.get(requestUrl, {
    params:{
      access_token: token,
      fields : '*,ogoneIncrement,user,organizationConfiguration',
      filter: JSON.stringify(filter),
    }
  });
};

export const getOrderLines = (token, orderId) => {
  const requestUrl = TTP_API_URL+`/billing/document_lines`;
  let filter = [];

  filter.push({
    property: 'documentType',
    value: 'ORDER',
    operator: 'eq'
  });

  filter.push({
    property: 'documentId',
    value: orderId,
    operator: 'eq'
  });

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter),
    }
  });
};

export const fetchErrorCallbackURL = (token, orderID) => {
    const requestUrl = TTP_API_URL+`/billing/order/errorCallbackURL/`+orderID;
    return axios.get(requestUrl, {
        params: {
            access_token: token,
        }
    });
};

export const getMerchantSignature = (token, orderId, sessionValidity, currencyCode, paymentAmount) => {
  const requestUrl = TTP_API_URL+`/payment/adyen/adyenKey`;
  var formData = new FormData();
  formData.append('access_token', token);
  formData.append('sessionValidity',sessionValidity);
  formData.append('currencyCode',currencyCode);
  formData.append('merchantAccount',MERCHANTACCOUNT);
  formData.append('paymentAmount',paymentAmount);
  formData.append('skinCode',SKINCODE);
  formData.append('merchantReference',orderId);
  formData.append('hmac',HMAC);
  return axios.post(requestUrl, formData);
};


export const verifyMerchantSig = (token, authResult, merchantReference, paymentMethod, pspReference, shopperLocale, skinCode) => {
  const requestUrl = TTP_API_URL+`/payment/purchaseOrder/merchantSig`;
  var formData = new FormData();
  formData.append('access_token', token);
  formData.append('authResult', authResult);
  formData.append('merchantReference',merchantReference);
  formData.append('paymentMethod',paymentMethod);
  formData.append('pspReference',pspReference);
  formData.append('shopperLocale',shopperLocale);
  formData.append('skinCode',skinCode);
  formData.append('hmac',HMAC);
  return axios.post(requestUrl, formData);
};

export const getAllOrders = (token, pageSize, pageNumber, searchValue, selectedValue, currentClient) => {
    const requestUrl = TTP_API_URL+`/payment/order`;
    let filter = [];
    if(searchValue && selectedValue)
    {
        filter.push({
            property: selectedValue,
            value: searchValue,
            operator: 'like'
        });
    }
    if(currentClient)
    {
        filter.push({
            property: 'issuer',
            value: currentClient.id,
            operator: 'eq'
        });
    }
    return axios.get(requestUrl, {
        params:{
            access_token: token,
            limit: pageSize || 10,
            start: (!pageNumber)? 0:((pageNumber - 1) * pageSize),
            filter: JSON.stringify(filter),
        }
    });
};

export const getAllUserOrders = (token, userID, clientID, pageSize, pageNumber, searchValue, selectedValue) => {
    const requestUrl = TTP_API_URL+`/payment/order`;
    let filter = [];
    if(searchValue && selectedValue)
    {
        filter.push({
            property: selectedValue,
            value: searchValue,
            operator: 'like'
        });
    }
    if(userID != 0) {
        filter.push({
            property: 'user',
            value: userID,
            operator: 'eq'
        });
    }
    if(clientID != 0) {
        filter.push({
            property: 'issuer',
            value: clientID,
            operator: 'eq'
        });
    }
    return axios.get(requestUrl, {
        params:{
            access_token: token,
            limit: pageSize || 10,
            start: (!pageNumber)? 0:((pageNumber - 1) * pageSize),
            filter: JSON.stringify(filter),
        }
    });
};

export const getAllBankTransfers = (token, pageSize, pageNumber, searchValue, selectedValue) => {
    const requestUrl = TTP_API_URL+`/payment/bankTransfer`;
    let filter = [];
    if(searchValue && selectedValue)
    {
        filter.push({
            property: selectedValue,
            value: searchValue,
            operator: 'like'
        });
    }
    return axios.get(requestUrl, {
        params:{
            access_token: token,
            limit: pageSize || 10,
            start: (!pageNumber)? 0:((pageNumber - 1) * pageSize),
            filter: JSON.stringify(filter),
        }
    });
};

export const createPayment = (token, attachment, issuerId) => {
    const requestUrl = TTP_API_URL+`/billing/coda-file/import`;
    var formData = new FormData();
    formData.append('access_token', token);
    for (let i=0;i<attachment.length;i++)
    {
        formData.append('files['+i+']', attachment[i]);
    }
    formData.append("issuerId", issuerId)
    return axios.post(requestUrl, formData);
};

export const getAllUsers = (token) => {
    const requestUrl = TTP_API_URL+`/payment/order/users`;
    return axios.get(requestUrl, {
        params:{
            access_token: token,
            nolimit: 1,
        }
    });
};

export const getStatistiques = (token) => {
    const requestUrl = TTP_API_URL+`/payment/order/statistique`;
    return axios.get(requestUrl, {
        params:{
            access_token: token,
            nolimit: 1,
        }
    });
};

export const paypalCallback = (token, orderID, paypalPayment) => {
    const requestUrl = TTP_API_URL+`/billing/paypal/paypal-callback`;
    var formData = new FormData();
    formData.append('access_token', token);
    formData.append('orderID', orderID);
    formData.append('email', paypalPayment.email);
    formData.append('payerID', paypalPayment.payerID);
    formData.append('paymentID', paypalPayment.paymentID);
    formData.append('paymentToken', paypalPayment.paymentToken);
    return axios.post(requestUrl, formData);
};


export const getCreditNotes = (token, pageSize, pageNumber, searchValue, selectedValue, currentClient) => {
    if(currentClient == null)
    {
    const requestUrl = TTP_API_URL+`/payment/creditNote`;
    let filter = [];
    if(searchValue && selectedValue)
    {
        filter.push({
            property: selectedValue,
            value: searchValue,
            operator: 'like'
        });
    }
    return axios.get(requestUrl, {
        params: {
        access_token: token,
        limit: pageSize || 10,
        start: (!pageNumber)? 0:((pageNumber - 1) * pageSize),
        filter: JSON.stringify(filter)
}
});}
    const requestUrl = TTP_API_URL+`/payment/creditNoteOrganisation`;
    let filter = [];
    if(searchValue && selectedValue)
    {
        filter.push({
            property: selectedValue,
            value: searchValue,
            operator: 'like'
        });
    }
    return axios.get(requestUrl, {
        params: {
            access_token: token,
            currentClientId: currentClient.id,
            limit: pageSize || 10,
            start: (!pageNumber)? 0:((pageNumber - 1) * pageSize),
            filter: JSON.stringify(filter)
        }
    });

};

export const getOrdersNotPayed = (token, transferId, field, currentClient, pageNumber) => {
    if(transferId && field)
    {
        return getSortedOrders(token, transferId, field, currentClient, pageNumber);
    }
    else if(!transferId && field) {
        return getSortedOrdersIfBankTransferNotChecked(token, field, currentClient, pageNumber);
    }
    const requestUrl = TTP_API_URL+`/payment/order`;
    let filter = [];
    filter.push(
        {
            property: 'status',
            value: 1,
            operator: 'eq'
        }
    );
    if(currentClient)
    {
            filter.push(
                {
                    property: 'issuer',
                    value: currentClient,
                    operator: 'in'
                }
            );
    }
    let params = {
        access_token: token,
        limit:  10,
        start: (!pageNumber)? 0:((pageNumber - 1) * 10),
    };

    params.filter = JSON.stringify(filter);
    return axios.get(requestUrl, {params});

};

export const getTransfersNotAssosiated = (token, orderId, field, pageNumber) => {
    if(orderId && field)
    {
        return getSortedTransfers(token, orderId, field, pageNumber);
    }

    else if(!orderId && field) {
        return getSortedTransfersIfOrderNotChecked(token, field, pageNumber);
    }
    const requestUrl = TTP_API_URL+`/payment/bankTransfer`;
    let filter = [
        {
            property: 'associationStatus',
            value: "NOT_ASSOCIATED",
            operator: 'eq'
        }
    ];
    let params = {
        access_token: token,
        limit:  10,
        start: (!pageNumber)? 0:((pageNumber - 1) * 10),
    };

    params.filter = JSON.stringify(filter);
    return axios.get(requestUrl, {params});

};

export const getSortedOrders = (token, transferId, field, currentClient, pageNumber) => {
    const requestUrl =TTP_API_URL+`/payment/order/sortedOrder`;
    return axios.get(requestUrl, {
        params:{
            access_token: token,
            transferId,
            field,
            currentClient,
            limit:  10,
            start: (!pageNumber)? 0:((pageNumber - 1) * 10),
        }
    });
};

export const getSortedOrdersIfBankTransferNotChecked = (token, field, currentClient, pageNumber) => {
    const requestUrl =TTP_API_URL+`/payment/order/sortedOrdersIfBankTransferNotChecked`;
    return axios.get(requestUrl, {
        params:{
            access_token: token,
            field,
            currentClient,
            limit:  10,
            start: (!pageNumber)? 0:((pageNumber - 1) * 10),
        }
    });
};

export const getSortedTransfers = (token, orderId, field,pageNumber ) => {
    const requestUrl =TTP_API_URL+`/payment/bankTransfer/sortedTransfer`;
    return axios.get(requestUrl, {
        params:{
            access_token: token,
            orderId,
            field,
            limit:  10,
            start: (!pageNumber)? 0:((pageNumber - 1) * 10),
        }
    });
};

export const getSortedTransfersIfOrderNotChecked = (token, field, pageNumber) => {
    const requestUrl =TTP_API_URL+`/payment/bankTransfer/sortedTransferIfOrderNotChecked`;
    return axios.get(requestUrl, {
        params:{
            access_token: token,
            field,
            limit:  10,
            start: (!pageNumber)? 0:((pageNumber - 1) * 10),
        }
    });
};

export const refundCreditNote = (token, creditNoteId, refundDate , refundType , note) => {
  const requestUrl = TTP_API_URL+`/billing/credit-note/`+creditNoteId;
  var formData = new FormData();
  formData.append('access_token', token);
  formData.append('status','REFUNDED');
  if(refundDate !== null) {
    formData.append('refundDate',refundDate);

  }

  if(refundType !== null) {
    formData.append('refundType',refundType);

  }

  if(note !== "") {
    formData.append('note',note);
  }
  return axios.post(requestUrl, formData);

};

export const validatePayment = (token, data, params) => {
    const requestUrl = TTP_API_URL+`/payment/payment/data`;
    var formData = new FormData();
    formData.append('access_token', token);
    for (let i=0;i<data.length;i++)
    {
        formData.append('data['+i+']', data[i]);
    }
    formData.append('params',params);
    return axios.post(requestUrl, formData);
};


export const validatePaymentTransfersToOrder = (token, data, params) => {
    const requestUrl = TTP_API_URL+`/payment/payment/data/transfers`;
    var formData = new FormData();
    formData.append('access_token', token);
    for (let i=0;i<data.length;i++)
    {
        formData.append('data['+i+']', data[i]);
    }
    formData.append('params',params);
    return axios.post(requestUrl, formData);
};

export const displayDocument = (token, documentId, type) => {

    const requestUrl = TTP_API_URL+`/billing/order/documentDisplay/`+type.toLowerCase()+`/`+documentId;

    window.open(requestUrl+`?access_token=`+token, '_blank');
};

export const validateIban = (token, clientID, iban) => {
    const requestUrl = TTP_API_URL+`/payment/order/validateIban`;
    var formData = new FormData();
    formData.append('access_token', token);
    formData.append('issuerID',clientID);
    formData.append('iban',iban);
    return axios.post(requestUrl, formData);
};

export const getMainIban = (token, issuerId) => {
    const requestUrl = TTP_API_URL+`/payment/order/issuerMainIban/`+issuerId;
    return axios.get(requestUrl, {
        params:{
            access_token: token,
        }
    });
};

export const getOgoneKey = (token, orderId, amount, language, comment, customerName, email, cancelURL, acceptURL) => {
    const requestUrl = TTP_API_URL+`/billing/ogone/generate-ogone-signature`;
    var formData = new FormData();
    formData.append('access_token', token);
    formData.append('PSPID',PSPID);
    formData.append('ORDERID',orderId);
    formData.append('AMOUNT',amount);
    formData.append('CURRENCY',CURRENCY);
    formData.append('LANGUAGE',language);
    formData.append('COM',comment);
    formData.append('CN',customerName);
    formData.append('EMAIL',email);
    formData.append('CANCELURL',cancelURL);
    formData.append('ACCEPTURL',acceptURL);
    return axios.post(requestUrl, formData);
};
export const fetchIssuerPayments = (token, pageSize, pageNumber, client, status, searchValue, selectedValue) => {
    const requestUrl = TTP_API_URL+`/payment/issuerPayment`;
    let filter = [];
    if(searchValue && selectedValue)
    {
        filter.push({
            property: selectedValue,
            value: searchValue,
            operator: 'like'
        });
    }
    if(client != 0)
    {
        filter.push({
            property: 'creditor',
            value: client,
            operator: 'eq'
        });
    }

    if(status != "")
    {
        filter.push({
            property: 'status',
            value: status,
            operator: 'eq'
        });
    }
    return axios.get(requestUrl, {
        params:{
            access_token: token,
            limit: pageSize || 10,
            start: (!pageNumber)? 0:((pageNumber - 1) * pageSize),
            filter: JSON.stringify(filter),
        }
    });
};

export const getUserCreditNoteInformation = (token, hachedUrl) => {
    const requestUrl =TTP_API_URL+`/billing/credit-note/to-refund`;
    return axios.get(requestUrl, {
        params:{
            access_token: token,
          hachedUrl,
        }
    });
};

export const getLatestIban = (token, userId) => {
    const requestUrl =TTP_API_URL+`/billing/credit-note/get-last-iban`;
    return axios.get(requestUrl, {
        params:{
            access_token: token,
            userId,
        }
    });
};

export const saveIban = (token, id, iban) => {
    const requestUrl =TTP_API_URL+`/billing/credit-note/`+id;
    var formData = new FormData();
    formData.append('access_token', token);
    formData.append('refundAccount',iban);
    return axios.post(requestUrl, formData);
};

export const ignoreBankTransfer = (token, bankTransfers) => {
  const requestUrl =TTP_API_URL+`/billing/bank-transfer/update-all-bank-transfers`;

  let formData = new FormData();
  formData.append('access_token', token);

  for (let bankTransfer of bankTransfers)
  {
    formData.append('bankTransfers[]', bankTransfer);
  }

  return axios.post(requestUrl, formData);
};

export const saveRefundDetails = (token, creditNoteId, firstName, lastName, rib, bank) => {

  const requestUrl = TTP_API_URL+`/billing/credit-note/`+creditNoteId;
  var formData = new FormData();
  formData.append('access_token', token);

  if(firstName !== null) {
    formData.append('firstName', firstName);
  }

  if(lastName !== null) {
    formData.append('lastName', lastName);
  }

  if(rib !== null) {
    formData.append('rib', rib);
  }

  if(bank !== null) {
    formData.append('bank', bank);
  }

  return axios.post(requestUrl, formData);
};


export const getRefundDetails = (token, creditNoteId) => {

  const requestUrl = TTP_API_URL+`/billing/credit-note/`+creditNoteId;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
    }
  });
};



// WEBPACK FOOTER //
// ./app/api/TamtamAPI/payment.js